const YOUTUBE_LONG_LINK_REGEXP =
  /^(https?:\/\/)?(www\.)?youtube\.com\/(watch\?v=[\w-]+|embed\/[\w-]+|shorts\/[\w-]+)(\S+)?$/;
const YOUTUBE_SHORT_LINK_REGEXP = /^(https?:\/\/)?(www\.)?youtu\.be\/[\w-]+(\S+)?$/;
const GDRIVE_LINK_REGEXP = /^(https?:\/\/)?drive\.google\.com\/file\/d\/[\w-]+(\/view)?(\?\S*)?$/;
const VIMEO_LINK_REGEXP = /^(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(\d+)(\?\S*)?$/;
const VIMEO_IFRAME_LINK_REGEXP = /^(?:https?:\/\/)?player\.vimeo\.com\/video\/(\d+)(\?\S*)?$/;
const VIMEO_PROGRESSIVE_LINK_REGEXP = /^https?:\/\/player\.vimeo\.com\/progressive_redirect\/download\/\d+\/.+\.\w+(\?.*)?$/i;
const EMAIL_REGEXP = /^[\w!#$%&'*+./=?^`{|}~-]+@[\dA-Za-z-]+(?:\.[\dA-Za-z-]+)*$/;
const PASSWORD_REGEXP = /^[^\sЁА-яё]*$/;
const SRT_TIME_REGEXP = /^\d{2}(?::[0-5]\d){2},\d{3}$/;

const isRegExpValid = (regexp: RegExp, value: string) => {
  return regexp.test(value);
};

export const isLinkValid = (value: string) => {
  return (
    isRegExpValid(YOUTUBE_LONG_LINK_REGEXP, value) ||
    isRegExpValid(YOUTUBE_SHORT_LINK_REGEXP, value) ||
    isRegExpValid(GDRIVE_LINK_REGEXP, value) ||
    isRegExpValid(VIMEO_LINK_REGEXP, value) ||
    isRegExpValid(VIMEO_IFRAME_LINK_REGEXP, value) ||
    isRegExpValid(VIMEO_PROGRESSIVE_LINK_REGEXP, value)
  );
};

export const validateLinks = (value: string) => {
  if (isLinkValid(value)) {
    return;
  }

  return 'Please provide correct link';
};

export const validateEmail = (value: string) => {
  if (isRegExpValid(EMAIL_REGEXP, value)) {
    return;
  }
  return 'Incorrect email';
};

export const validatePassword = (value: string) => {
  if (value.length < 6) {
    return 'At least 6 characters';
  }
  if (isRegExpValid(PASSWORD_REGEXP, value)) {
    return;
  }
  return 'Incorrect password';
};

export const isSrtTimeValid = (value: string) => {
  return isRegExpValid(SRT_TIME_REGEXP, value);
};
